import { Suspense, lazy } from 'react';

import { Loader } from 'shared/ui/Loader';

const UomManagement = lazy(() => import('./UomManagement'));

export default () => (
  <Suspense fallback={<Loader />}>
    <UomManagement />
  </Suspense>
);
